'use strict';

var d3 = require('d3');
var DateRangeChart = function DateRangeChart(AbstractChart, chartGroups, chartSimpleBars, chartCircles, chartTiles, chartXAxis, chartYAxis, chartBrush, chartConstants, svgPatternService) {
  var chartParams = require('./Params');
  var chartScales = require('./Scales');
  var Chart = function Chart(container, formatters) {
    AbstractChart.call(this, container);
    svgPatternService.initPatterns(['user-exclusion', 'user-exclusion-viewport']);
    var dispatch = d3.dispatch('rangechange', 'rangechangeend', 'maxvisiblerangechange');
    d3.rebind(this, dispatch, 'on');

    // chart components
    var brush = chartBrush();
    var groups = chartGroups('departureDateMoment', formatters.tooltipFormatter, true);
    var m1Bars = chartSimpleBars('m1');
    var m2Bars = chartSimpleBars('m2');
    var tiles = chartTiles('departureDateMoment', 'm2', 'tiles').withHeight(2);
    var circles = chartCircles('circles');
    var xAxis = chartXAxis(formatters.xAxisTickFormatter).withoutLine();
    var yAxisLeft = chartYAxis(formatters.yAxisTickFormatter, chartConstants.AXIS.MODE.LEFT);
    var maxRangeSize;
    function getSelectionRange(selectionSize, domainLength) {
      if (selectionSize > 0) {
        return [0, Math.min(selectionSize, domainLength)];
      } else {
        return [Math.max(0, domainLength + selectionSize), domainLength];
      }
    }
    function updateBrushSelection(selectionSize, domainLength, resetting) {
      var initializingChart = selectionSize !== undefined;
      var resizingChart = selectionSize === undefined;
      if (initializingChart) {
        brush.setSelection(getSelectionRange(selectionSize, domainLength));
      }
      if (resizingChart) {
        brush.setSelection(brush.getSelection());
      }
      if (resetting) {
        dispatch.rangechangeend(brush.getSelection());
      }
    }
    this.render = function (data, range) {
      this.initChart(data, this.getMaxRange(range), chartParams);
      this.scales = chartScales(this.params, this.data, this.visibleXRange);
      this.setMaxRangeSize();
      this.callForPreDataGroup([brush.withDomainRange(this.visibleXRange)], this.scales);
      this.callForDataGroup([yAxisLeft, groups, m2Bars, m1Bars, tiles, circles, xAxis], this.scales);
      if (brush.isSelectionInitialized()) {
        brush.updateBrush();
      }
    };
    this.domainChange = function (range) {
      this.render(this.data, range);
    };
    this.setInitialSelection = function (range, silent) {
      brush.setInitialSelection(range, silent);
    };
    this.getSelection = function () {
      return brush.getSelection();
    };
    this.setMaxRangeSize = function () {
      var maxWidth = 15 / 0.9; //group (bar + padding) width, refers to Scales.js:24
      var chartWidth = chartParams(this.container.width()).width;
      var newMaxRangeSize = Math.floor(chartWidth / maxWidth);
      if (newMaxRangeSize !== maxRangeSize) {
        maxRangeSize = newMaxRangeSize;
        dispatch.maxvisiblerangechange(newMaxRangeSize);
      }
    };
    this.getMaxRange = function (range) {
      if (typeof range === 'undefined') {
        return range;
      }
      this.setMaxRangeSize();
      var delta = range[1] - range[0];
      if (delta > maxRangeSize) {
        range[1] = range[0] + maxRangeSize;
      }
      return range;
    };
    this.getMaxRangeSize = function () {
      return maxRangeSize;
    };
    brush.on('brushchange', function (range, triggerEnd) {
      this.callForYAxis(yAxisLeft, this.scales);
      this.brushChangeAction(range, groups);
      dispatch.rangechange(range);
      if (triggerEnd) {
        dispatch.rangechangeend(range);
      }
    }.bind(this));
    brush.on('brushend', function (range, silent) {
      dispatch.rangechangeend(range, silent);
    });
    groups.on('groupclick', function (d, i) {
      brush.setSelection([i, i + 1]);
      dispatch.rangechangeend(brush.getSelection());
    });
    this.withMetric = function (metric) {
      yAxisLeft.label(metric.label);
      return this;
    };
    this.resetBrushSelection = function () {
      updateBrushSelection(this.data.length, this.data.length, true);
    };
    container.on('$destroy', function () {
      groups.on('groupclick', null);
      brush.on('brushchange', null);
      brush.on('brushend', null);
    });
  };
  Chart.prototype = Object.create(AbstractChart.prototype);
  Chart.constructor = Chart;
  return Chart;
};
DateRangeChart.$inject = ['AbstractChart', 'ChartElementsGroup', 'ChartElementsSimpleBars', 'ChartElementsCircles', 'ChartElementsTiles', 'ChartElementsXAxis', 'ChartElementsYAxis', 'ChartElementsMultiBrush', 'ChartElementsConstants', 'SvgPatternService'];
module.exports = DateRangeChart;